import React from "react";

function FooterBtn(props) {
  let { show = true, title, cb, children, isActive = false, addClass = "", disable = false } = props;
  return (
    show && (
      <button
        title={disable ? "Disabled" : title}
        disabled={disable}
        onClick={cb}
        className={`adder ${addClass} ${isActive ? "active" : ""}`}
      >
        {children}
      </button>
    )
  );
}

export default FooterBtn;
